import styled from '@emotion/styled';
import MuiInputLabel, { inputLabelClasses } from '@mui/material/InputLabel';

export const StyledInputLabel = styled(MuiInputLabel)`
    &.${inputLabelClasses.root} {
        position: relative;
        top: 0;
        left: 0;
        transform: none;
        color: ${(props) => props.theme.colorsUnifications.gunmetal['100']};
        font-size: ${(props) => props.theme.fontSize.regularS};
        font-weight: 600;
        font-family: NotoSans, Helvetica, sans-serif;

        &.${inputLabelClasses.focused} {
            color: ${(props) => props.theme.colorsUnifications.gunmetal['100']};
        }
    }
`;
